module.exports = __webpack_public_path__ + "static/media/zs_husova.8280e40c.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/sponsors/zs_husova.png
// module id = 434
// module chunks = 0